export const Dashbord = () => {
  return <div>Dashboard page</div>;
};
